import { AfterViewInit, Component, ElementRef, inject, ViewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogRef } from '@angular/material/dialog';
import { MatFormField } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-input-dialog',
  templateUrl: './input-dialog.component.html',
  styleUrls: ['./input-dialog.component.scss'],
  imports: [
    CardComponent,
    MatButton,
    MatDialogClose,
    MatFormField,
    MatInput,
    MatIcon,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class InputDialogComponent implements AfterViewInit {
  dialogRef = inject(MatDialogRef<InputDialogComponent>);
  data: {
    text: string;
    title: string;
    lines: number;
    placeholder?: string;
    initialContent?: string;
  } = inject(MAT_DIALOG_DATA);

  @ViewChild('inputField') myInputField: ElementRef;

  ngAfterViewInit() {
    this.myInputField.nativeElement.focus();
  }

  result = this.data.initialContent ?? '';

  submit() {
    this.dialogRef.close(this.result);
  }
}
